<div class="row mt-4">
    <div class="col-12 text-center mb-4">
        <img src="./assets/img/exclamation.svg" alt="">
    </div>
    <div class="col-12 px-4">
        <ul *ngIf="listErrors.length > 0" class="list-options pl-4">
            <li *ngFor="let error of listErrors" class="text-color-secondary mb-2"><span>{{error}}</span></li>
        </ul>
    </div>
    <div class="col-12 text-center my-3">
        <button mat-dialog-close mat-flat-button class="style-button-1 mt-2 w-30  mat-elevation-z3">
            <span>Aceptar</span>
        </button>
    </div>
</div>
